export const traitDictionary = {
  "white eyes":
    { chromosome: "X", position: 1.5, category: "eyes", name: "white eyes", symbol: "w", lethal: false, dominant: false },
  "facet eyes":
    { chromosome: "X", position: 3, category: "eyes", name: "facet eyes", symbol: "fa", lethal: false, dominant: false },
  "echinus eyes":
    { chromosome: "X", position: 5.5, category: "eyes", name: "echinus eyes", symbol: "ec", lethal: false, dominant: false },
  "ruby eyes":
    { chromosome: "X", position: 7.5, category: "eyes", name: "ruby eyes", symbol: "rb", lethal: false, dominant: false },
  "crossveinless wings":
    { chromosome: "X", position: 13.7, category: "wings", name: "crossveinless wings", symbol: "cv", lethal: false, dominant: false },
  "cut wings":
    { chromosome: "X", position: 20, category: "wings", name: "cut wings", symbol: "ct", lethal: false, dominant: false },
  "singed bristles":
    { chromosome: "X", position: 21, category: "bristles", name: "singed bristles", symbol: "sn", lethal: false, dominant: false },
  "tan body":
    { chromosome: "X", position: 27.5, category: "body", name: "tan body", symbol: "t", lethal: false, dominant: false },
  "vermillion eyes":
    { chromosome: "X", position: 33, category: "eyes", name: "vermillion eyes", symbol: "v", lethal: false, dominant: false },
  "miniature wings":
    { chromosome: "X", position: 36.1, category: "wings", name: "miniature wings", symbol: "m", lethal: false, dominant: false },
  "sable body":
    { chromosome: "X", position: 43, category: "body", name: "sable body", symbol: "s", lethal: false, dominant: false },
  "garnet eyes":
    { chromosome: "X", position: 44, category: "eyes", name: "garnet eyes", symbol: "g", lethal: false, dominant: false },
  "scalloped wings":
    { chromosome: "X", position: 51.5, category: "wings", name: "scalloped wings", symbol: "sd", lethal: false, dominant: false },
  "forked bristles":
    { chromosome: "X", position: 56.7, category: "bristles", name: "forked bristles", symbol: "f", lethal: false, dominant: false },
  "bar eyes":
    { chromosome: "X", position: 57, category: "eyes", name: "bar eyes", symbol: "B", lethal: false, dominant: true },
  "fused veins":
    { chromosome: "X", position: 59.5, category: "veins", name: "fused veins", symbol: "fu", lethal: false, dominant: false },
  "carnation eyes":
    { chromosome: "X", position: 62.5, category: "eyes", name: "carnation eyes", symbol: "car", lethal: false, dominant: false },
  "bobbed bristles":
    { chromosome: "X", position: 66, category: "bristles", name: "bobbed bristles", symbol: "bb", lethal: false, dominant: false },
  "aristaless antennae":
    { chromosome: 1, position: 0, category: "antennae", name: "aristaless antennae", symbol: "al", lethal: false, dominant: false },
  "star eyes":
    { chromosome: 1, position: 1.3, category: "eyes", name: "star eyes", symbol: "S", lethal: true, dominant: true },
  "held-out wings":
    { chromosome: 1, position: 4, category: "wings", name: "held-out wings", symbol: "ho", lethal: false, dominant: false },
  "curly wings":
    { chromosome: 1, position: 6.1, category: "wings", name: "curly wings", symbol: "Cy", lethal: true, dominant: true },
  "dumpy wings":
    { chromosome: 1, position: 13, category: "wings", name: "dumpy wings", symbol: "dp", lethal: false, dominant: false },
  "clot eyes":
    { chromosome: 1, position: 16.5, category: "eyes", name: "clot eyes", symbol: "cl", lethal: false, dominant: false },
  "spade wings":
    { chromosome: 1, position: 21.9, category: "wings", name: "spade wings", symbol: "spd", lethal: false, dominant: false },
  "dachs tarsi":
    { chromosome: 1, position: 31, category: "tarsi", name: "dachs tarsi", symbol: "d", lethal: false, dominant: false },
  "daughterless":
    { chromosome: 1, position: 41.5, category: "misc", name: "daughterless", symbol: "da", lethal: false, dominant: false },
  "black body":
    { chromosome: 1, position: 48.5, category: "body", name: "black body", symbol: "b", lethal: false, dominant: false },
  "reduced bristles":
    { chromosome: 1, position: 51.2, category: "bristles", name: "reduced bristles", symbol: "rd", lethal: false, dominant: false },
  "purple eyes":
    { chromosome: 1, position: 54.5, category: "eyes", name: "purple eyes", symbol: "pr", lethal: false, dominant: false },
  "light eyes":
    { chromosome: 1, position: 55.9, category: "eyes", name: "light eyes", symbol: "lt", lethal: false, dominant: false },
  "cinnabar eyes":
    { chromosome: 1, position: 57.5, category: "eyes", name: "cinnabar eyes", symbol: "c", lethal: false, dominant: false },
  "vestigial wings":
    { chromosome: 1, position: 67, category: "wings", name: "vestigial wings", symbol: "vg", lethal: false, dominant: false },
  "lobe eyes":
    { chromosome: 1, position: 72, category: "eyes", name: "lobe eyes", symbol: "L", lethal: false, dominant: true },
  "curved wings":
    { chromosome: 1, position: 75.5, category: "wings", name: "curved wings", symbol: "C", lethal: false, dominant: true },
  "smooth abdomen":
    { chromosome: 1, position: 91.5, category: "abdomen", name: "smooth abdomen", symbol: "sm", lethal: false, dominant: false },
  "brown eyes":
    { chromosome: 1, position: 104.5, category: "eyes", name: "brown eyes", symbol: "bw", lethal: false, dominant: false },
  "speck body":
    { chromosome: 1, position: 107, category: "body", name: "speck body", symbol: "sp", lethal: false, dominant: false },
  "javelin bristles":
    { chromosome: 2, position: 19.2, category: "bristles", name: "javelin bristles", symbol: "jv", lethal: false, dominant: false },
  "sepia eyes":
    { chromosome: 2, position: 26, category: "eyes", name: "sepia eyes", symbol: "se", lethal: false, dominant: false },
  "hairy body":
    { chromosome: 2, position: 26.5, category: "body", name: "hairy body", symbol: "h", lethal: false, dominant: false },
  "eye gone":
    { chromosome: 2, position: 35.5, category: "gone", name: "eye gone", symbol: "eyg", lethal: false, dominant: false },
  "dichaete wings/bristles":
    { chromosome: 2, position: 41, category: "wings", name: "dichaete wings/bristles", symbol: "D", lethal: true, dominant: true },
  "scarlet eyes":
    { chromosome: 2, position: 44, category: "eyes", name: "scarlet eyes", symbol: "st", lethal: false, dominant: false },
  "antennapedia":
    { chromosome: 2, position: 47.5, category: "misc", name: "antennapedia", symbol: "Antp", lethal: true, dominant: true },
  "pink eyes":
    { chromosome: 2, position: 48, category: "eyes", name: "pink eyes", symbol: "p", lethal: false, dominant: false },
  "curled wings":
    { chromosome: 2, position: 50, category: "wings", name: "curled wings", symbol: "cu", lethal: false, dominant: false },
  "stubble bristles":
    { chromosome: 2, position: 58.2, category: "bristles", name: "stubble bristles", symbol: "Sb", lethal: true, dominant: true },
  "spineless":
    { chromosome: 2, position: 58.5, category: "misc", name: "spineless", symbol: "ss", lethal: false, dominant: false },
  "bithorax body":
    { chromosome: 2, position: 58.7, category: "body", name: "bithorax body", symbol: "bx", lethal: false, dominant: false },
  "stripe body":
    { chromosome: 2, position: 62, category: "body", name: "stripe body", symbol: "sr", lethal: false, dominant: false },
  "glass eyes":
    { chromosome: 2, position: 63.1, category: "eyes", name: "glass eyes", symbol: "gl", lethal: false, dominant: false },
  "delta veins":
    { chromosome: 2, position: 66.2, category: "veins", name: "delta veins", symbol: "Dl", lethal: false, dominant: true },
  "hairless":
    { chromosome: 2, position: 69.5, category: "misc", name: "hairless", symbol: "H", lethal: false, dominant: true },
  "ebony body":
    { chromosome: 2, position: 70.7, category: "body", name: "ebony body", symbol: "e", lethal: false, dominant: false },
  "cardinal eyes":
    { chromosome: 2, position: 74.7, category: "eyes", name: "cardinal eyes", symbol: "cd", lethal: false, dominant: false },
  "mahogany eyes":
    { chromosome: 2, position: 88, category: "eyes", name: "mahogany eyes", symbol: "mah", lethal: false, dominant: false },
  "minute bristles":
    { chromosome: 2, position: 106.2, category: "bristles", name: "minute bristles", symbol: "M", lethal: false, dominant: true },
  "grooveless scutellum":
    { chromosome: 3, position: 0, category: "misc", name: "grooveless scutellum", symbol: "gvl", lethal: false, dominant: false },
  "bent wings":
    { chromosome: 3, position: 0, category: "wings", name: "bent wings", symbol: "bt", lethal: false, dominant: false },
  "eyeless":
    { chromosome: 3, position: 2, category: "eyes", name: "eyeless", symbol: "ey", lethal: false, dominant: false }
}
